// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2cAds","filesListContainer":"PosDisputesFiles_filesListContainer__3btUT","filesButton":"PosDisputesFiles_filesButton__1SNxv"};